import React, { useEffect, useState, useCallback } from "react";
import API from "../Services/PriceType";

const PriceType = ({ selectedPriceType, setSelectedPriceType }) => {

    const [pricetype, setPriceType] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedPriceType(e.target.value);
    };

    const bindPriceType = async () => {
        try {

            const response = await API.bindPriceType({
                is_active:1,
                limit:0
            });
            setPriceType(response?.data?.data?.rows);
          
        } catch (error) {
            setError("Failed to fetch Price Type.");
            console.error(error);
             if (error.response.status === 403) {
                window.location.replace("/Login");
              }
        }
    };
    useEffect(() => {
        bindPriceType();
    }, []);

    return (
        <div className="row">
            <div className="col-md-12">
                {/* <div className="form-group"> */}
                    <label htmlFor="Designation" className="mb-1">Price Type <span style={{color:"red"}}>*</span></label>
                    <select className="form-select" id="ddltype" value={selectedPriceType}
                        onChange={handleChange}>
                        <option value="">Select</option>
                        {pricetype.length > 0 ? (
                            pricetype.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.type}
                                </option>
                            ))
                        ) : (
                            <option disabled>No PriceType available</option>
                        )}
                    </select>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                {/* </div> */}
            </div>
        </div>
    );
};

export default PriceType;
